import { Record } from 'immutable';

const ProgressTestsPlanRecord = Record({
  id: undefined,
  index: undefined,
  progressReportId: undefined,
  name: undefined,
  unitIds: undefined,
  isCurrentProgressTest: undefined,
  isUnitQuiz: undefined,
  startTime: undefined,
});

class ProgressTestsPlan extends ProgressTestsPlanRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
    case 'progressReportId':
      return [key, `${val}`]; // stringify
    case 'unitIds':
      return [key, val.map((v) => `${v}`)];
    default:
      return [key, val];
  }
};

ProgressTestsPlan.create = (data) =>
  new ProgressTestsPlan(data).mapEntries(reviver);

export default ProgressTestsPlan;



// WEBPACK FOOTER //
// ./data/ProgressTestsPlan/model/model.js